<div class="bg-slate-50/60 pb-8">
  <!-- Header -->
  <header class="flex flex-wrap justify-between items-center gap-4 mb-6">
    <div>
      <h1 class="text-2xl font-bold text-slate-900">Dashboard</h1>
      <p class="text-sm text-slate-500 mt-0.5">{{ todayLabel() }}</p>
    </div>
    <div class="flex flex-wrap items-center gap-3">
      <div class="flex items-center gap-2 px-3 py-2 rounded-lg border border-slate-200 bg-white text-slate-600 text-sm">
        {{ periodLabel() }}
      </div>
      <div class="flex rounded-lg border border-slate-200 bg-white overflow-hidden">
        @for (opt of periodOptions; track opt.value) {
          <button
            type="button"
            (click)="setPeriod(opt.value)"
            class="px-3 py-2 text-sm font-medium transition-colors"
            [class.bg-blue-600]="period().type === opt.value && opt.value !== 'custom'"
            [class.text-white]="period().type === opt.value && opt.value !== 'custom'"
            [class.bg-slate-100]="period().type !== opt.value"
            [class.text-slate-600]="period().type !== opt.value">
            {{ opt.label }}
          </button>
        }
      </div>
      @if (period().type === 'custom') {
        <div class="flex items-center gap-2 flex-wrap">
          <input type="date" [value]="customDateFrom()"
            (input)="customDateFrom.set($any($event.target).value)"
            class="rounded-lg border border-slate-200 px-2 py-1.5 text-sm">
          <span class="text-slate-400">–</span>
          <input type="date" [value]="customDateTo()"
            (input)="customDateTo.set($any($event.target).value)"
            class="rounded-lg border border-slate-200 px-2 py-1.5 text-sm">
          <button type="button" (click)="applyCustomPeriod()"
            [disabled]="!customDateFrom() || !customDateTo() || data()?.loading"
            class="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
            Aplicar
          </button>
        </div>
      }
      <p-button label="Agregar widget" icon="pi pi-plus" [outlined]="true"
        (onClick)="widgetMenu.toggle($event)" />
      <p-menu #widgetMenu [model]="addWidgetMenuItems()" [popup]="true" appendTo="body" />
      <p-button label="Restablecer" icon="pi pi-refresh" [text]="true"
        (onClick)="resetLayout()" />
      <button type="button" (click)="refresh()" [disabled]="data()?.loading"
        class="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 text-sm font-medium disabled:opacity-50">
        <span class="inline-block w-4 h-4 border-2 border-slate-400 border-t-transparent rounded-full animate-spin"
          [class.invisible]="!data()?.loading"></span>
        Actualizar
      </button>
      <a [routerLink]="['/invoices/nuevo']"
        class="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors">
        Nueva factura
      </a>
    </div>
  </header>

  @if (data()?.error) {
    <div class="mb-4 rounded-lg border border-amber-200 bg-amber-50 text-amber-800 px-4 py-3 text-sm">
      {{ data()?.error }}
    </div>
  }

  <!-- Grid dinámico -->
  <div class="rounded-xl border border-slate-200/80 w-full overflow-hidden"
       [style.min-height.px]="gridsterMinHeightPx()">
    <gridster [options]="gridsterOptions">
      @for (item of gridItems(); track item.id) {
        <gridster-item [item]="item">
          <!-- La clase pento-dash-widget-card usa position:absolute inset:0 (estilos del host) -->
          <div class="pento-dash-widget-card">
            <!-- Barra de arrastre -->
            <div class="pento-dash-drag-handle shrink-0 flex items-center justify-between gap-2
                        px-3 py-2 bg-slate-50/90 border-b border-slate-100
                        cursor-grab active:cursor-grabbing select-none">
              <span class="text-xs font-medium text-slate-600 truncate">
                {{ widgetTitle(item.widgetType) }}
              </span>
              <button type="button"
                class="pento-dash-no-drag shrink-0 w-6 h-6 rounded flex items-center justify-center
                       text-slate-400 hover:text-red-600 hover:bg-red-50 text-base leading-none"
                (click)="removeWidget(item.id); $event.stopPropagation()"
                title="Quitar widget">×</button>
            </div>
            <!-- Contenido del widget -->
            <div class="pento-dash-no-drag flex-1 min-h-0 overflow-hidden">
              @switch (item.widgetType) {
                @case ('kpi-collection')       { <app-dash-kpi-collection      [data]="data()" /> }
                @case ('kpi-projection')       { <app-dash-kpi-projection      [data]="data()" /> }
                @case ('kpi-pending')          { <app-dash-kpi-pending         [data]="data()" /> }
                @case ('kpi-rate')             { <app-dash-kpi-rate            [data]="data()" /> }
                @case ('sales-chart')          { <app-dash-sales-chart         [data]="data()" /> }
                @case ('collection-timeline')  { <app-dash-collection-timeline [data]="data()" /> }
                @case ('collection-breakdown') { <app-dash-collection-breakdown [data]="data()" /> }
                @case ('upcoming-overdue')     { <app-dash-upcoming-overdue    [data]="data()" /> }
                @case ('invoice-status')       { <app-dash-invoice-status      [data]="data()" /> }
                @case ('recent-payments')      { <app-dash-recent-payments     [data]="data()" /> }
              }
            </div>
          </div>
        </gridster-item>
      }
    </gridster>
  </div>
</div>
